var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgInstagram(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".instagram_a,.instagram_c{fill:#44476a;}.instagram_b{clip-path:url(#a);}.instagram_c{fill-rule:evenodd;}"), /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    className: "instagram_a",
    d: "M0,0H17.5V17.5H0Z"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "instagram_b"
  }, /*#__PURE__*/React.createElement("path", {
    className: "instagram_c",
    d: "M15.455,7.39H13.934a5.375,5.375,0,1,1-10.4,0H2.016v7.392a.672.672,0,0,0,.673.671H14.782a.672.672,0,0,0,.673-.671Zm0-4.7a.672.672,0,0,0-.673-.672H12.767a.672.672,0,0,0-.672.672V4.7a.672.672,0,0,0,.672.672h2.015a.672.672,0,0,0,.673-.672ZM8.735,5.375a3.36,3.36,0,1,0,3.36,3.359,3.359,3.359,0,0,0-3.36-3.359m6.72,12.095H2.015A2.016,2.016,0,0,1,0,15.453V2.015A2.015,2.015,0,0,1,2.015,0h13.44A2.015,2.015,0,0,1,17.47,2.015V15.453a2.016,2.016,0,0,1-2.015,2.017"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgInstagram);
export default __webpack_public_path__ + "static/media/instagram.abaa1fe8187ea63e88d85ffe86b00b41.svg";
export { ForwardRef as ReactComponent };